import { TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import { Body } from "../ui/Typography";

interface BudgetTableHeaderProps {
  months: string[];
}

export const BudgetTableHeader = ({ months }: BudgetTableHeaderProps) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell
          className="sticky left-0 z-20 bg-background shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]"
          sx={{
            borderBottom: '1px solid rgba(224, 224, 224, 1)',
            borderRight: '1px solid rgba(224, 224, 224, 1)',
            fontWeight: 'bold',
            backgroundColor: 'background.default',
            '&::after': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'inherit',
              zIndex: -1,
            }
          }}
        >
          <Body className="flex items-center gap-2">
            Konto
          </Body>
        </TableCell>
        <TableCell
          sx={{
            borderBottom: '1px solid rgba(224, 224, 224, 1)',
            borderRight: '1px solid rgba(224, 224, 224, 1)',
            fontWeight: 'bold',
          }}
        >
          <Body>
            Beskrivning
          </Body>
        </TableCell>
        {months.map((month) => (
          <TableCell
            key={month}
            align="right"
            sx={{
              borderBottom: '1px solid rgba(224, 224, 224, 1)',
              borderRight: '1px solid rgba(224, 224, 224, 1)',
              fontWeight: 'bold',
              '&:last-child': {
                borderRight: 'none'
              }
            }}
          >
            <Body>
              {month}
            </Body>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};